import React, {memo} from 'react';
import {Button} from "reactstrap";
import {
    ConfirmationText,
    CongratulationsText,
    ContentWrapper,
    PaymentSuccessContainer,
    OrderStatusIcon,
    SuccessMessage,
    Title
} from "../../orderComplete.style";

const SuccessIconSVG = memo(() => (
    <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_7084_5655" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="11" y="8" width="108"
              height="114">
            <path
                d="M65.0001 10.8359L79.227 21.2143L96.8392 21.1818L102.248 37.9409L116.515 48.2651L111.042 65.0026L116.515 81.7401L102.248 92.0643L96.8392 108.823L79.227 108.791L65.0001 119.169L50.7732 108.791L33.1609 108.823L27.7524 92.0643L13.4849 81.7401L18.9584 65.0026L13.4849 48.2651L27.7524 37.9409L33.1609 21.1818L50.7732 21.2143L65.0001 10.8359Z"
                fill="#555555" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M46.0415 65.0026L59.5832 78.5443L86.6665 51.4609" stroke="white" strokeWidth="4"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </mask>
        <g mask="url(#mask0_7084_5655)">
            <path d="M0 0H130V130H0V0Z" fill="#0B9C07"/>
        </g>
    </svg>
))

const SplitBuyPaymentSuccess = memo(() => {
    return (
        <PaymentSuccessContainer>
            <ContentWrapper>
                <Title>Split Buy Payment</Title>
                <OrderStatusIcon>
                    <SuccessIconSVG/>
                </OrderStatusIcon>

                <SuccessMessage>
                    <CongratulationsText>
                        Payment Successful! You're now<br/>
                        part of our split-buy.
                    </CongratulationsText>
                    <ConfirmationText>
                        Congratulations! 🎉 your payment is<br/>
                        confirmed. We have also sent the confirmation of payment to your email.
                    </ConfirmationText>
                </SuccessMessage>
            </ContentWrapper>
            <a href="/split-buy" className={"mobile-sticky-checkout"}>
                <Button className={"custom-app-btn"}>
                    Re-Direct To Home
                </Button>
            </a>

        </PaymentSuccessContainer>
    );
})

export default SplitBuyPaymentSuccess;